module.exports = __webpack_public_path__ + "static/media/access_icon.7ede93ae.svg";